import React, { useEffect, useMemo, useRef, useState } from 'react'
import { enumUtil } from '../../../../../../../../utils/Enum';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import DropdownValueHandler from '../../../../../../../shared/SuperSearch/DropdownValueHandler';
import EncounterDetails from '../EncounterDetails/EncounterDetails';
import isNull from '../../../../../../../../utils/NullChecking';
import ReloadGridAction from '../../../../../../../../actions/ReloadGridAction';
import { ServerRequestProtected } from '../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../utils/NotificationHandler';
import SectionScrollNavigator from './Components/SectionScrollNavigator';
import Loader from '../../../../../../../shared/Loader/Loader';
import FormValidator from '../../../../../../../../utils/FormValidator';
import { encounterStatus } from '../Components/Constants';
import TherapyNote from './TherapyNote';
import { FindFirstChild } from '../../../../../../../../utils/FindMenuOption';
import { Modal } from "react-bootstrap";
import ModalHeader from '../../../../../../../Setup/Shared/ModalHeader';
import { GeneralDropDowns } from '../../../../../../../../actions/GeneralPatientActions';
import { getNoteDisplaySettings } from '../Components/utils';
import { Separator } from '../../../../../../../EHR/utils/utils';
import useCustomTemplateItemsValidation from '../Components/Custom Template Form/Components/useCustomTemplateItemsValidation';

const TherapyNotewithDetails = ({ templateDataToApply, setTemplateDataToApply, ...props}) => {
    let { patientID, encounterID } = props;
    let isEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd;
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType);
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    console.log("propsTherapywithDetails",props)
    const SearchCriteria = {
        "EncounterType": "",
        "NoteType": "Therapy",
        "EncounterDate": "",
        "SeenBy": "",
        "Facility": "",
        "EncounterStatus": "In Progress",
        "VitalUnitType": "US Customary",
        "PatientAppointmentID": ""
    }
    const [searchParam, setSearchParam] = useState(SearchCriteria);
    const encounterNotesDisplay = useSelector(state => state?.EncounterNotesDisplaySettingsReducer);
    const DEFAULT_PREVIEW_SELECTED = {
        ...encounterNotesDisplay
    }
    const [defaultSelectedItems, setDefaultSelectedItems] = useState(DEFAULT_PREVIEW_SELECTED);
    const [selectedItems, setSelectedItems] = useState(DEFAULT_PREVIEW_SELECTED);
    const encounterNotesDisplaySetting = useMemo(() => {
        if (!encounterNotesDisplay || !(encounterNotesDisplay?.length > 0)) {
            return {};
        }

        return getNoteDisplaySettings(encounterNotesDisplay, searchParam?.SeenBy, searchParam?.NoteType);
    }, [encounterNotesDisplay, searchParam?.SeenBy, searchParam?.NoteType]);
    
    useEffect(() => {
        if (!encounterNotesDisplaySetting || Object.keys(encounterNotesDisplaySetting).length === 0) {
        } else {
            setDefaultSelectedItems(encounterNotesDisplaySetting)
            setSelectedItems(encounterNotesDisplaySetting);
        }
    },[ encounterNotesDisplaySetting ])
    
    // let {searchParam, setSearchParam, SearchCriteria} = props;
    let providerDD = useSelector(state => state.GeneralDropDownsReducer.Provider);
    let locationDD = useSelector(state => state.GeneralDropDownsReducer.Location);

    let dispatch = useDispatch();
    const scrollableDivRef = useRef(null);
    const scrollIntervalRef = useRef(null);
    const API_URL = enumUtil.controller.PatientEncounter;
    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    // let EncounterIDR =
    //     useSelector(state =>
    //         state.Open_Patient_Tab?.find((pt) => pt.active === true)
    //             ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
    //             ?.data?.id
    //     );
    ///////////////// Custom Import Form //////////////////////
    const { validationItemsModal, handleSetDefaultItemsForValidation } = useCustomTemplateItemsValidation();
    const [customTemplateData, setCustomTemplateData] = useState([]);
    const [saveCustomTemplateData, setSaveCustomTemplateData] = useState([]);
    ///////////////////////////////////////////////////////////
    const [mainServiceLineModal, setMainServiceLineModal] = useState([]);
    const [encounterExistConfirmation, setEncounterExistConfirmation] = useState(false);
    const [saveCMSData, setSaveCMSData] = useState({
        "CurrentMentalStatusID" :"",
    });
    
    const [saveInterventionsUsed, setSaveInterventionsUsed] = useState({
        "InterventionsUsedID" :"",
    });

    const [saveResponseObs, setSaveResponseObs] = useState({
        "ResponseObservationsID" :"",
    });
    const [saveAddendumData, setSaveAddendumData] = useState([]);
    const [saveQualityOfCareData, setSaveQualityOfCareData] = useState({
        "QualityOfCareID" :"",
    });
    const [reloadAfterSave, setReloadAfterSave] = useState(false);
    const [activeID, setActiveID] = useState(null);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [saveEncounterCoSignData, setSaveEncounterCoSignData] = useState([]);

    let ITEM_DATA = [
        {
            "EHRComponentItemID": "",
            "EHRComponentID": "",
            "ItemID": "Notes-0",
            "name": "Notes",
            "content": "Chief Complaint",
            "options": null,
            "selectedOptions": null,
            "MultiLineAnswer": null,
            "answer": null,
            "noOfHeaders": null,
            "isDeleted": "false",
            "order": "0",
            "noOfRows": null,
            "headers": null,
            "rows": null,
            "file": null
        },
        {
            "EHRComponentItemID": "",
            "EHRComponentID": "",
            "ItemID": "Notes-1",
            "name": "Notes",
            "content": "Notes",
            "options": null,
            "selectedOptions": null,
            "MultiLineAnswer": null,
            "answer": null,
            "noOfHeaders": null,
            "isDeleted": "false",
            "order": "1",
            "noOfRows": null,
            "headers": null,
            "rows": null,
            "file": null
        }
    ];
    ////////////// Maybe its the apply Repeat Past Encounters /////////////////
    const DEFAULT_TEMPLATE_DATA = {
        EHRTemplateID: "",
        TemplateName: "Therapy",
        TemplateType: "Therapy",
        Data: [
            {
                "EHRTemplateID": "",
                "key": "SUBJECTIVE",
                "type": "Component-Based",
                "items": ITEM_DATA
            },
            {
                "EHRTemplateID": "",
                "key": "OBJECTIVE",
                "type": "Component-Based",
                "items": ITEM_DATA
            },
            {
                "EHRTemplateID": "",
                "key": "RESPONSE",
                "type": "Component-Based",
                "items": ITEM_DATA
            },
            {
                "EHRTemplateID": "",
                "key": "PLAN",
                "type": "Component-Based",
                "items": ITEM_DATA
            },
            {
                "EHRTemplateID": "",
                "key": "NOTES",
                "type": "Component-Based",
                "items": ITEM_DATA
            }
        ]
    }
    const [templateData, setTemplateData] = useState(DEFAULT_TEMPLATE_DATA);
    ///////////////////////////////////////////////////////////////////////////

    const [showPreview, setShowPreview] = useState(false);
    const [printoutSelectDataModal, setPrintoutSelectDataModal] = useState(false);
    const [printoutModal, setPrintoutModal] = useState(false);

    let ACCORD_DATA = [
        { active: true, key: 'SUBJECTIVE', type: 'Component-Based' },
        { active: true, key: 'OBJECTIVE', type: 'Component-Based' },
        { active: true, key: 'RESPONSE', type: 'Component-Based' },
        { active: true, key: 'PLAN', type: 'Component-Based' },
        { active: true, key: 'AdditionalINFO', type: 'Component-Based' },
    ]
    const [accordions, setAccordions] = useState(ACCORD_DATA);

    const SearchCriteriaName = {
        "EncounterType": "",
        "NoteType": "Other Note",
        "SeenBy": "",
        "Facility": "",
        "EncounterStatus": "In Progress",
    }
    const [searchValue, setSearchValue] = useState(SearchCriteriaName)
    const SearchCriteriaNameCMS = {
        "Orientation": "",
        "Insight": "",
        "GeneralAppearance": "",
        "JudgementAndImpulseControl": "",
        "Dress": "",
        "Memory": "",
        "MotorActivity": "",
        "AttentionConcentration": "",
        "InterviewBehaviour": "",
        "ThoughtProcess": "",
        "Speech": "",
        "ThoughtContent": "",
        "Mood": "",
        "Perception": "",
        "Affect": "",
        "FunctionalStatus": ""
    }
    const [searchValueCMS, setSearchValueCMS] = useState(SearchCriteriaNameCMS)

    let ENCOUNTER_DEFAULT_MODEL = {
        "TableName": enumUtil.enumAPITableName.TherapyNote,
        "Data": {
            "EncounterID": "",
            "PatientID": patientID || "",
            "EncounterType": "",
            "NoteType": "Therapy",
            "EncounterDate": format(new Date(), 'MM/dd/yyyy'),
            "SeenBy": "",
            "Facility": "",
            "EncounterStatus": "In Progress",
            "VitalUnitType":"US Customary",
            "ChiefComplaint": "",
            // "OtherNote": "",
            "SubjectiveNotes": "",
            "ObjectiveNotes": "",
            "InterventionNotes": "",  
            "ResponseNotes": "",      
            "AssesmentNotes": "",
            "PlanNotes": "",

            "FollowUpDate" : "",
            "FollowUpNotes" : ""
            // "AdditionalInfoNotes": ""
        },
        "EncounterProblem": [],
        "CurrentMentalStatus": {},
        "InterventionsUsed": {},
        "ResponseObservations": {},
        "RiskAssessment": [],

        "EncounterDocument": [],
        "EncounterAddendum": [],
        "QualityOfCare" : {},
        "SuperBill":[]
    }

    const [is, setIs] = useState(true);
    const [isCMS, setIsCMS] = useState(true);
    const [encounterData, setEncounterData] = useState(ENCOUNTER_DEFAULT_MODEL);

    // const [cmsDDData, setCMSDDData] = useState([])
    const [appointmentData, setAppointmentData] = useState([])
    const API_URL_General = enumUtil.controller.General
    // const [encounterID, setEncounterID] = useState('');
    // const [patientID, setPatientID] = useState('');

    useEffect(() => {
        // setEncounterID(EncounterIDR);
        // setPatientID(PatientIDR);
        // ServerRequestProtected(API_URL_General + "/DropDown", 'post', {
        //     "TableName": enumUtil.enumAPITableName.Encounter,
        //     "ID": patientID,
        // })
        // .then((response) => {
        //     setAppointmentData(response)
        // }).catch((error) => {
        // })

        // Current Mental Status Dropdown //
        
        if (!DropDowns?.TherapyNote || Object.keys(DropDowns.TherapyNote).length === 0) {
            ServerRequestProtected(API_URL + "/EncounterDropDown", 'post', {
                "TableName": enumUtil.enumAPITableName.EncounterDropDown,
                "ID": patientID,
            })
            .then((response) => {
                dispatch(GeneralDropDowns({ ...DropDowns, TherapyNote: response}));
                // setCMSDDData(response)
            }).catch((error) => {
            })
        }
            
    }, [])

    const startScrolling = (direction) => {
        if (!scrollableDivRef.current) return;

        // Start the interval for scrolling
        scrollIntervalRef.current = setInterval(() => {
            scrollableDivRef.current.scrollBy({
                top: direction === "down" ? 10 : -10, // Scroll 10px at a time
            });
        }, 16); // Repeat every 1ms
    };

    const stopScrolling = () => {
        // Clear the interval to stop scrolling
        if (scrollIntervalRef.current) {
            clearInterval(scrollIntervalRef.current);
            scrollIntervalRef.current = null;
        }
    };
    ///////////////////////////////////////////////////
    useEffect(() => {
        if (templateDataToApply?.key) {
            let accordExist = accordions?.map(it => it.key).includes(templateDataToApply?.key);

            setTemplateData(prev => {
                return {
                    ...prev,
                    Data: accordExist ?
                        (prev?.Data?.map(accord =>
                            accord.key === templateDataToApply.key ?
                                {
                                    ...accord,
                                    items: [
                                        ...accord.items,
                                        ...templateDataToApply.items.filter(
                                            item =>
                                                !accord.items.some(
                                                    it => it.EHRComponentItemID === item.EHRComponentItemID
                                                )
                                        ),
                                    ],
                                } : accord)) : [...prev?.Data, templateDataToApply]
                }
            });
            let { key, type } = templateDataToApply;
            setAccordions(prev => accordExist ? prev : [...prev, { active: true, key, type }])
            setTemplateDataToApply({});
        }
    }, [templateDataToApply])

    useEffect(() => {
        if (!isNull(props.Reload) && encounterID &&!['-1', -1, 0, ""].includes(encounterID)) {
            let data = props.id
            data.map((item) => {
                if (item.key === 218) {
                    LoadData()
                }
            })
            if (data.length === 0) {
                LoadData()
            }
        }
        }, [props.Reload, encounterID]);

    useEffect(() => {
        if (!reloadAfterSave) return;
        LoadData();
    }, [reloadAfterSave])

    let SAVE_TRIGGER_MODEL = {
        // 'SUBJECTIVE': false, 
        // 'OBJECTIVE': false, 
        // 'RESPONSE': false, 
        // 'PLAN': false, 
        // 'AdditionalINFO': false 
        // 'SOAP': false,
        'Therapy': false,
    };
    const [saveTrigger, setSaveTrigger] = useState(SAVE_TRIGGER_MODEL);
    const [saveModal, setSaveModel] = useState({});

    const getSaveData = async () => {
        if(!isEditAllowed) return;
        const valModal = await childRef.current?.EncounterDetailsValidation(); // call child's validate
        let validationEncDetails = FormValidator([valModal], enumUtil.enumValidationType.NullCheck);

        const valTherapyIsNotValid= await childTherapyRef.current?.CPTValidation(); // call child's validate
        console.log("validationTherapyvalTherapyExists",validationEncDetails, valTherapyIsNotValid)

        if (validationEncDetails || valTherapyIsNotValid) {
            setSaveTrigger(SAVE_TRIGGER_MODEL)
            return
        } else {
            setSaveTrigger(
                { [searchParam.NoteType]: true },
            );
        }
    }

    const onSave = (type, val) => {
        setSaveModel(prev => ({ ...prev, [type]: val }));
        setSaveTrigger(prev => ({ ...prev, [type]: "callSave" }));
    }

    const getSaveModel = () => {
        // if (searchParam.NoteType === "SOAP") {
        //     return saveModal.SOAP;
        // }

        if (searchParam.NoteType === "Therapy") {
            return saveModal.Therapy;
        }
    }
    const handleSave = (updatedParams) => {
        setIsLoading(true)
        console.log("handleSave")
        let saveData = getSaveModel();
        if(updatedParams?.SaveDuplicateEncounter === "true"){
            saveData.Data.SaveDuplicateEncounter = updatedParams.SaveDuplicateEncounter;
        }
        // console.log(" handleEncounterExists updatedParams saveData", saveData, updatedParams);
        ServerRequestProtected(API_URL + "/SaveTherapyNote", 'post', {
            ...saveData
        })
            .then((response) => {
                setIsLoading(false);
                NotificationHandler('Record Saved Successfully', enumUtil.enumtoaster.success);
                    let newObj = {
                        key: 2,
                        name: "Encounter",
                        active: true,
                        data: {
                            id: response.id,
                            name: searchParam.EncounterDate,
                            time: new Date(),
                        },
                    };
                    dispatch({
                        type: 'Open_New_Encounter_Tab',
                        payload: {
                            patientId: patientID,
                            encounterId: encounterID,
                            newObj: newObj
                        }
                    });

                // }
                setReloadAfterSave(true);
                dispatch(ReloadGridAction({ EncounterSearch: true }));
            }).catch((error) => {
                setIsLoading(false)
                console.log("Error Error", error?.response?.data)
                if(error?.response?.data === "An encounter already exists for the selected date"){
                    handleEncounterExists(saveData.Data.EncounterDate);
                } else {
                    error?.response?.data && NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
                }
            })
    }

    useEffect(() => {
        const callSave = Object.values(saveTrigger).every(val => val === "callSave");
        console.log("callSave", saveTrigger, callSave)
        if (callSave) {
            handleSave();
            setSaveTrigger(SAVE_TRIGGER_MODEL); // reset after save
        }
    }, [saveTrigger])

    const LoadData = () => {
        if (['-1', -1, 0, ""].includes(encounterID)) return;
        setSearchParam(SearchCriteria);
        setSearchValue(SearchCriteriaName);
        setSearchValueCMS(SearchCriteriaNameCMS);
        setEncounterData(ENCOUNTER_DEFAULT_MODEL);
        setSaveCustomTemplateData([]); // reset Save on reload
        setSaveEncounterCoSignData([]);
        setShowPreview(false);
        setIsLoading(true);
        setReloadAfterSave(false);
        ServerRequestProtected(API_URL + "/GetTherapyNote", 'post', {
            "TableName": enumUtil.enumAPITableName.TherapyNote,
            "ID": encounterID,
        })
            .then((response) => {
                setIsLoading(false);
                setSearchParam(prev => ({
                    ...prev,
                    "EncounterType": response?.Data?.EncounterType,
                    "NoteType": response?.Data?.NoteType,
                    "EncounterDate": response?.Data?.EncounterDate,
                    "SeenBy": response?.Data?.SeenBy,
                    "Facility": response?.Data?.Facility,
                    "EncounterStatus": response?.Data?.EncounterStatus,
                    "VitalUnitType": response?.Data?.VitalUnitType,
                    "PatientAppointmentID": response?.Data?.PatientAppointmentID,
                }));
                setEncounterData(prev => ({
                    ...prev,
                    ...response,
                    Data: { ...prev?.Data, ...response?.Data }
                }));
                setCustomTemplateData(response?.CustomTemplate || [])
                
                let { TableName: TableNameCMS, ...cmsData } = response.CurrentMentalStatus;
                setSaveCMSData(prev => ({ ...prev, ...cmsData }))
                setIsCMS(true);

                let { TableName: TableNameIU , ...responseInterventionsUsed} = response.InterventionsUsed;
                setSaveInterventionsUsed(prev => ({ ...prev, ...responseInterventionsUsed }));
                
                let { TableName: TableNameRO , ...responseObsData } = response.ResponseObservations;
                setSaveResponseObs(prev => ({ ...prev, ...responseObsData }));
                
                let { TableName, ...qocData } = response.QualityOfCare;
                setSaveQualityOfCareData(prev => ({ ...prev, ...qocData }));

                setShowPreview(["Signed" , "To Be Co-Signed"].includes(response?.Data?.EncounterStatus) || !isEditAllowed);
                setSearchValue(prev => ({
                    ...prev,
                    "EncounterType": DropdownValueHandler(visitTypes, response?.Data?.EncounterType),
                    "NoteType": DropdownValueHandler(noteTypes, response?.Data?.NoteType),
                    "SeenBy": DropdownValueHandler(providerDD, response?.Data?.SeenBy),
                    "Facility": DropdownValueHandler(locationDD, response?.Data?.Facility),
                    "EncounterStatus": DropdownValueHandler(encounterStatus, response?.Data?.EncounterStatus) || "",
                    "PatientAppointmentID": response?.Data?.PatientAppointmentID ? response?.Data?.EncounterDate : "",
                }));
                setIsProcedureEdit(response?.SuperBill?.length > 0 ? false  : true)
                setIs(true);
            }).catch((error) => {
                setIsLoading(false)
            })
    }

    const [isProcedureEdit, setIsProcedureEdit] = useState(false);
    const childRef = useRef();
    const childTherapyRef = useRef();
    
    const confirmationMsg = (EncounterDate) => {
        return new Promise((resolve, reject) => {
            const handleConfirmation = (userConfirmed) => {
                if (userConfirmed) {
                    resolve(userConfirmed);
                } else { reject(userConfirmed); }
                setEncounterExistConfirmation(<></>);
            };
            setEncounterExistConfirmation(
                <Modal show={true} onHide={() => handleConfirmation(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
                    <ModalHeader HeaderName={Heading} DeletePopup={""} isClosed={() => handleConfirmation(false)} key={6331} Name={'DuplicateEncounter'} />
                    <Modal.Body>
                        <div className='ar-alert d-flex mb-12'>
                            <i className='icon-Vector13 mt-1'></i>
                            <div>
                                <p className='text ms-1'>Encounter already exists for {EncounterDate}. Do you want to create another encounter?</p>
                            </div>
                        </div>
                    </Modal.Body>

                    <div className="modal_footer za_br_light br-top-1 pt-2 ">
                        <div className='za-button text-end d-flex justify-content-end gap-2'>
                            <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => handleConfirmation(false)}>No</button>
                            <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => handleConfirmation(true)}>Yes</button>
                        </div>
                    </div>
                </Modal>)
        })
    }
    
    const Heading = () => {
        return <p className='heading Rejected_clr'>Confirmation Message</p>;
    };

    const handleEncounterExists = async(EncounterDate) => {
        const userConfirmed = await confirmationMsg(EncounterDate);
        console.log("handleEncounterExists", userConfirmed);
        if(userConfirmed){
            let updatedParams = { ...searchParam, SaveDuplicateEncounter: "true" };
            setSearchParam(() => updatedParams);
            handleSave(updatedParams);
        }
    }
    const insertPosition = customTemplateData?.[0]?.InsertPosition || '';

  return (    
    <>
        {isLoading ? <Loader /> : null}
        {encounterExistConfirmation}
        <EncounterDetails ref={childRef} is={is} setIs={setIs} 
        defaultSelectedItems={defaultSelectedItems} setDefaultSelectedItems={setDefaultSelectedItems} setSelectedItems={setSelectedItems}
        insertPosition={insertPosition}
        customTemplateData={customTemplateData} setCustomTemplateData={setCustomTemplateData}
        setSaveCustomTemplateData={setSaveCustomTemplateData}
        handleSetDefaultItemsForValidation={handleSetDefaultItemsForValidation}
        saveAddendumData={saveAddendumData} setSaveAddendumData={setSaveAddendumData} searchParam={searchParam} setSearchParam={setSearchParam} searchValue={searchValue} setSearchValue={setSearchValue} providerDD={providerDD} locationDD={locationDD} setSaveTrigger={setSaveTrigger} initialData={encounterData} setShowPreview={setShowPreview} showPreview={showPreview} setReloadAfterSave={setReloadAfterSave}
        printoutSelectDataModal={printoutSelectDataModal} setPrintoutSelectDataModal={setPrintoutSelectDataModal} setIsProcedureEdit={setIsProcedureEdit} scrollTo={props?.scrollTo} setScrollTo={props?.setScrollTo}  handleNoteTypeChange={props?.handleNoteTypeChange} patientID={patientID} encounterID={encounterID} mainServiceLineModal={mainServiceLineModal} setSaveEncounterCoSignData={setSaveEncounterCoSignData}/>
        <div className="ar-encounter-detail-content">
            <div className="d-flex gap-10 ">
                {showPreview ? null :
                    <div className="h-100 ar-side-line d-flex flex-column gap-5">
                        <div className="ar-icon d-flex align-items-center justify-content-center"
                            onMouseDown={() => startScrolling("up")}
                            onMouseUp={stopScrolling}
                            onMouseLeave={stopScrolling}>
                            <i className="icon-up fs-10"></i>
                        </div>
                        <div className="d-flex flex-column gap-5 options-scroll" ref={scrollableDivRef}>
                            <SectionScrollNavigator encounterID={encounterID} activeID={activeID} setActiveID={setActiveID} hoveredItem={hoveredItem} setHoveredItem={setHoveredItem} defaultSelectedItems={defaultSelectedItems} customTemplateData={customTemplateData}/>
                        </div>
                        <div className="ar-icon d-flex align-items-center justify-content-center"
                            onMouseDown={() => startScrolling("down")}
                            onMouseUp={stopScrolling}
                            onMouseLeave={stopScrolling}>
                            <i className="icon-down fs-10"></i>
                        </div>
                    </div>}
                <div className="w-100 pt-1-5 hover-scrollbar scroll pe-1-5">
                    {/* Therapy Note */}
                    {searchParam.NoteType === "Therapy" &&
                            <TherapyNote
                                ref={childTherapyRef}
                                encounterID={encounterID}
                                key={encounterData?.Data?.EncounterID}
                                saveEncounterCoSignData={saveEncounterCoSignData}
                                // cmsDDData={cmsDDData}
                                saveAddendumData={saveAddendumData}
                                searchValueCMS={searchValueCMS} 
                                setSearchValueCMS={setSearchValueCMS}
                                saveCMSData={saveCMSData}
                                setSaveCMSData={setSaveCMSData}
                                saveInterventionsUsed={saveInterventionsUsed}
                                setSaveInterventionsUsed={setSaveInterventionsUsed}
                                saveResponseObs={saveResponseObs}
                                setSaveResponseObs={setSaveResponseObs}
                                saveQualityOfCareData={saveQualityOfCareData}
                                setSaveQualityOfCareData={setSaveQualityOfCareData}
                                setAccordions={setAccordions}
                                initialData={encounterData}
                                saveSignal={saveTrigger.Therapy}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSave={onSave}
                                setActiveID={setActiveID}
                                setHoveredItem={setHoveredItem}
                                isRecordSaved={props?.isRecordSaved}
                                isRecordSavedType={props?.isRecordSavedType}
                                showPreview={showPreview}
                                searchValue={searchValue}
                                patientID={patientID}
                                isProcedureEdit={isProcedureEdit}
                                setIsProcedureEdit={setIsProcedureEdit}   
                                printoutSelectDataModal={printoutSelectDataModal} 
                                setPrintoutSelectDataModal={setPrintoutSelectDataModal} 
                                printoutModal={printoutModal} 
                                setPrintoutModal={setPrintoutModal} 
                                getSaveData={getSaveData}
                                setReloadAfterSave={setReloadAfterSave}
                                mainServiceLineModal={mainServiceLineModal} 
                                setMainServiceLineModal={setMainServiceLineModal}
                                isCMS={isCMS}
                                setIsCMS={setIsCMS}
                                defaultSelectedItems={defaultSelectedItems}
                                selectedItems={selectedItems} 
                                setSelectedItems={setSelectedItems}

                                insertPosition={insertPosition}
                                customTemplateData={customTemplateData} 
                                setCustomTemplateData={setCustomTemplateData}

                                saveCustomTemplateData={saveCustomTemplateData}
                                setSaveCustomTemplateData={setSaveCustomTemplateData}
                                validations={validationItemsModal} 
                            />
                        }

                </div>
            </div>
            {showPreview ? null :
                <div className='tabs-action-bottom br-top-1 br-bottom-1 align-items-center justify-content-between d-flex br-clr mx-0 position-static z-unset px-1 h-100 py-1 px-2'>
                    <div className="">
                        <p className='heading heading_ext d-flex align-items-center gap-01'>Updated By/Date: <span className='text text_color'>{encounterData?.Data?.UpdatedBy || 'N/A'}, {encounterData?.Data?.UpdateDate || 'N/A'}</span></p>
                    </div>
                    <div className="">
                        <button className={`btn btn-orange ${isEditAllowed ? '' : 'disabled'}`} onClick={getSaveData}>Save</button>
                    </div>
                </div>
            }
        </div>
    </>
  )
}

export default TherapyNotewithDetails